import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.header`
  padding: 32px 0;
  background: #f8f8f8;
  border-bottom: 1px solid #ddd;
`;

export const HeaderContent = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > button {
    background: transparent;
    border: 0;

    svg {
      color: ${(props) => props.theme.colors.primary};
      width: 24px;
      height: 24px;
      transition: color 0.2s;
    }

    &:hover {
      svg {
        color: ${(props) => props.theme.colors.error};
      }
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    line-height: 1.5;

    span {
      color: ${(props) => props.theme.colors.text_light};
    }

    strong {
      color: ${(props) => props.theme.colors.text};
      font-size: 1.2rem;
    }
  }
`;
